import script from "./loginIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./loginIndex.vue?vue&type=script&setup=true&lang=js"

import "./loginIndex.vue?vue&type=style&index=0&id=1c40e0d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c40e0d0"]])

export default __exports__